module.exports = __webpack_public_path__ + "static/media/bhempire.4b5ca212.webp";